import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceSyncStatus } from '@era/locations-sdk';

@Component({
  selector: 'era-device-mdm-sync-retry-ui',
  templateUrl: './device-mdm-sync-retry.component.html',
  styleUrls: ['./device-mdm-sync-retry.component.scss'],
})
export class DeviceMdmSyncRetryComponent {
  @Input() public deviceSyncStatus: DeviceSyncStatus;
  @Output() public readonly retry = new EventEmitter<DeviceSyncStatus>();

  public onRetry() {
    this.retry.emit(this.deviceSyncStatus);
  }
}
